/* eslint-disable max-len */
import React from 'react'
import { ShimmerBadge, ShimmerText, ShimmerThumbnail, ShimmerTitle } from 'react-shimmer-effects'
export default function Skeleton(){
    return(
        <div>
            <div className=" opacity-100 transition-opacity duration-150 ease-linear data-[te-tab-active]:block" id="tabs-institutionDetails" role="tabpanel" aria-labelledby="tabs-institutionDetails-tab">
                <div className='pt-5'></div>
                <p className="text-2xl font-bold text-[#031624] mt-5"><ShimmerTitle line={1} gap={7}  variant="secondary" className="w-[100px]"/></p>
                <h5 className="text-2xl font-bold text-[#031624]"><ShimmerBadge width={150}/> 
                    <span className='ml-4'>  <ShimmerBadge width={100}/></span> </h5>  
                {[...Array(2)].map((i)=>(
                    <>
                        <p className="text-2xl font-bold text-[#031624] mt-5"><ShimmerTitle line={1} gap={7}  variant="secondary" className="w-[100px]"/></p>
                        <h5 className="text-2xl font-bold text-[#031624]"><ShimmerBadge width={150}/>  </h5>  
                    </>
                ))}
                
                <div className=" w-[55%] pt-2 ml-9">
                    <div className="w-full">
                        <div className="flex -ml-[10px] mb-2">
                            <div className="w-1/2">
                                <div className="w-full">
                                    <p className="text-2xl font-bold text-[#031624] mt-[1px] "><ShimmerTitle line={1} gap={7}  variant="secondary" className="w-[80px]"/></p>
                                    <p><ShimmerText /><span><ShimmerText/></span></p>
                                    
                                </div>
                            </div>
                            <div className="w-full ml-[70px]">
                                <p className="text-2xl font-bold text-[#031624] mt-[1px] "><ShimmerTitle line={1} gap={7}  variant="secondary" className="w-[80px]"/></p>
                                <p><ShimmerText /><span><ShimmerText/></span></p>
                                    
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    )
}